<div class="lm-list-container lmc">
    <div>
        <span class="card-title">{{title}}</span>
        <ng-container *ngIf="_showAuditOutOfSyncWarning">
            <span class="tag is-dismissible hide-focus lpl-yellow-bg" style="margin-left: 5px; margin-bottom: 4px">{{ 'NotAllChangesReplicated' | translate }}</span>
        </ng-container>
    </div>
  <div class="main-content filterlist-content-area">
      <div soho-datagrid></div>
  </div>
</div>
